import CloseIcon from "~/icons/CloseIcon";
import styles from "./IconButton.module.scss";
import React from "react";

export default function IconButtonClose({ onClick }) {
    return (
        <div onClick={onClick} className={styles["icon-button"]}>
            <CloseIcon />
        </div>
    );
}
